export * from "../global/device-video";
